/* Code generated with AutoHTML Plugin for Figma */
import { FeedBackRequest, ID } from "@project/shared-types";
import { useState } from "react";
import { SendFeedBackAPI } from "../../api/account/SendFeedBack";
import {
  _colorText,
  _size,
  _sizeText,
  _style,
  _typeInput,
} from "../../core/core";
import { useLocalStorage } from "../../shared/hooks/useLocalStorage";
import { Button } from "../button/button";
import { Input } from "../inputs/Input";
import { Star } from "../Star/Star";
import { Text } from "../texts/text";
import "./FeedBack.css";

interface FeedBackProps {
  count?: number;
  id: ID;
  is_order: boolean;
  stars_ready?: boolean;
  title?: string;
  [key: string]: any; // Для дополнительных свойств
}

export const FeedBack: React.FC<FeedBackProps> = ({
  count = 5,
  id,
  is_order,
  stars_ready,
  title = "Вам понравилась работа?",
  ...props
}) => {
  const [stars, setStars] = useState<boolean[]>(new Array(count).fill(false));
  const [isActive, setIsActive] = useState<boolean>(false);
  const [number, setNumber] = useState<number>(0);
  const [comment, setComment] = useState<string>("");

  const [token, setToken] = useLocalStorage<string>("token", "");
  const [feedBackOrders, setFeedBackOrders] = useLocalStorage<ID[]>(
    "feedback_orders",
    []
  );

  const handleClick = (num: number) => {
    const newStars = stars.map((_, index) => index < num);
    setStars(newStars);
    setIsActive(true);
    setNumber(num);
  };

  const onMouseEnterStar = (num: number) => {
    if (isActive) return;
    const newStars = stars.map((_, index) => index < num);
    setStars(newStars);
  };

  const onMouseExitStar = () => {
    if (isActive) return;
    setStars(stars.map(() => false));
  };

  const getStarsReady = () =>
    stars.map((_, index) => (
      <Star
        key={index}
        number={index + 1}
        active={true}
        handleClick={handleClick}
        handleMouseEnter={onMouseEnterStar}
        handleMouseLeave={onMouseExitStar}
      />
    ));

  const getStars = () =>
    stars.map((isActive, index) => (
      <Star
        key={index}
        number={index + 1}
        active={isActive}
        handleClick={handleClick}
        handleMouseEnter={onMouseEnterStar}
        handleMouseLeave={onMouseExitStar}
      />
    ));

  const getQuestion = () => {
    if (!isActive) return null;

    const questionText =
      number < 5
        ? "Расскажите, что не понравилось?"
        : "Расскажите, что можно улучшить?";

    return (
      <>
        <Text size={_sizeText.m} color={_colorText.black}>
          {questionText}
        </Text>
        <Input
          type={_typeInput.text}
          value={comment}
          setValue={setComment}
          size={_size.M}
          placeholder="Комментарий"
        />
        <Button
          style={_style.secondary2}
          width="100%"
          size={_size.M}
          onClick={sendFeedBack}
        >
          Отправить
        </Button>
      </>
    );
  };

  const sendFeedBack = async () => {
    const dataOrder = {
      text: comment,
      stars: number,
      is_order: is_order,
      id: id,
    } as FeedBackRequest;

    try {
      const response = await SendFeedBackAPI(dataOrder);
      if (!response) return;
      setFeedBackOrders([...(feedBackOrders ?? []), id ?? 0]);
    } catch (error) {
      console.error("Ошибка отправки отзыва:", error);
    }
  };
  const isActiveFeedBack = () =>
    Array.isArray(feedBackOrders) && !feedBackOrders.includes(id ?? 0);

  return (
    <div className="feed-back" {...props}>
      {stars_ready ? (
        <div className="feedback-main">
          <Text size={_sizeText.m} color={_colorText.black}>
            {title}
          </Text>
          <div className="feedback-stars">{getStarsReady()}</div>
        </div>
      ) : (
        <>
          {isActiveFeedBack() ? (
            <div className="feedback-main">
              <Text size={_sizeText.m} color={_colorText.black}>
                {title}
              </Text>
              <div className="feedback-stars">{getStars()}</div>
              {getQuestion()}
            </div>
          ) : (
            <div className="feedback-main">
              <Text size={_sizeText.m} color={_colorText.black}>
                Спасибо, что поделились своим мнением ❤️
              </Text>
            </div>
          )}
        </>
      )}
    </div>
  );
};
